module.exports = __webpack_public_path__ + "img/30.719c1d28.png";